// Serializa tarefas assíncronas: a próxima só começa depois que a anterior
// terminar (com sucesso ou erro) — garante que duas atualizações não se
// misturem. Usado pelo Store do app browser (src/app/store.ts) e pelo
// servidor multiusuário (server/main.ts); mora fora de src/domain porque não
// é regra de negócio, e fora de src/app porque o servidor também usa.

export type Enfileirar = <T>(tarefa: () => Promise<T>) => Promise<T>;

export function criarFilaSequencial(): Enfileirar {
  let fila: Promise<unknown> = Promise.resolve();
  return (tarefa) => {
    const proxima = fila.then(tarefa);
    // a fila segue viva mesmo quando uma tarefa falha
    fila = proxima.catch(() => undefined);
    return proxima;
  };
}
